<template>
  <div class="home">
    <!-- Hero -->
    <section class="hero">
      <div class="container hero__inner">
        <div class="hero__text">
          <span class="hero__eyebrow hero__anim" style="--d:0ms">扎根嘉兴 · 专业房产经纪</span>
          <h1 class="hero__anim" style="--d:120ms">三剑合璧<br />为您安家嘉兴每一步</h1>
          <p class="hero__anim" style="--d:240ms">浙江嘉兴市三剑客房产经纪有限责任公司，提供二手房买卖、新房代理、房屋租赁与置业咨询的一站式服务。透明交易、专业陪伴，让好房不难找。</p>
          <div class="hero__actions hero__anim" style="--d:360ms">
            <router-link to="/properties" class="btn btn--primary">浏览优质房源</router-link>
            <router-link to="/register" class="btn btn--ghost">免费注册咨询</router-link>
          </div>
          <div class="hero__stats hero__anim" style="--d:480ms">
            <div><strong><CountUp :to="12" /></strong><span>年本地深耕</span></div>
            <div><strong><CountUp :to="3800" suffix="+" /></strong><span>成交套数</span></div>
            <div><strong><CountUp :to="98" suffix="%" /></strong><span>客户满意度</span></div>
          </div>
        </div>
        <div class="hero__card hero__float">
          <h3>快速找房</h3>
          <p class="hero__card-sub">告诉我们需求，专属顾问为您匹配</p>
          <label>意向区域
            <select v-model="q.district">
              <option>不限</option><option>南湖区</option><option>秀洲区</option>
              <option>嘉善县</option><option>桐乡市</option><option>海宁市</option><option>平湖市</option>
            </select>
          </label>
          <label>交易类型
            <select v-model="q.type">
              <option>二手房</option><option>新房</option><option>租赁</option><option>商铺</option>
            </select>
          </label>
          <label>预算区间
            <select v-model="q.budget">
              <option>100万以下</option><option>100-200万</option>
              <option>200-400万</option><option>400万以上</option>
            </select>
          </label>
          <router-link to="/register" class="btn btn--primary btn--block">立即匹配房源</router-link>
        </div>
      </div>
    </section>

    <!-- 服务优势 -->
    <section class="section">
      <div class="container">
        <div class="section-head">
          <span class="eyebrow">Why Choose Us</span>
          <h2>为什么选择三剑客房产</h2>
          <p>专业、透明、贴心，把每一次置业都当成自己的家来经营。</p>
        </div>
        <div class="grid grid-4">
          <div class="feature" v-for="(f, i) in features" :key="f.title" v-reveal="i * 100">
            <div class="feature__icon" v-html="f.icon"></div>
            <h3>{{ f.title }}</h3>
            <p>{{ f.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 精选房源 -->
    <section class="section section--soft">
      <div class="container">
        <div class="section-head">
          <span class="eyebrow">Featured</span>
          <h2>本周精选房源</h2>
          <p>覆盖嘉兴各区县的优质房源，实勘实拍，信息真实。</p>
        </div>
        <div class="grid grid-3">
          <div v-for="(p, i) in featured" :key="p.id" v-reveal="i * 120">
            <PropertyCard :item="p" />
          </div>
        </div>
        <div style="text-align:center; margin-top:40px;">
          <router-link to="/properties" class="btn btn--outline">查看全部房源</router-link>
        </div>
      </div>
    </section>

    <!-- 服务流程 -->
    <section class="section">
      <div class="container">
        <div class="section-head">
          <span class="eyebrow">Process</span>
          <h2>省心置业四步走</h2>
        </div>
        <div class="steps">
          <div class="step" v-for="(s, i) in steps" :key="s.t" v-reveal="i * 110">
            <div class="step__no">{{ i + 1 }}</div>
            <h3>{{ s.t }}</h3>
            <p>{{ s.d }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="cta">
      <div class="container cta__inner">
        <div>
          <h2>想快人一步找到心仪好房？</h2>
          <p>注册成为会员，获取专属顾问 1 对 1 服务与最新房源推送。</p>
        </div>
        <router-link to="/register" class="btn btn--primary">立即免费注册</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import PropertyCard from '@/components/PropertyCard.vue'
import CountUp from '@/components/CountUp.vue'
import { featured as featuredList } from '@/data/properties.js'

export default {
  name: 'HomeView',
  components: { PropertyCard, CountUp },
  data() {
    return {
      q: { district: '不限', type: '二手房', budget: '100-200万' },
      features: [
        { title: '真房源保障', desc: '房源实勘实拍，价格真实透明，杜绝虚假信息。', icon: '🏠' },
        { title: '专属顾问', desc: '一对一置业顾问全程陪同，需求匹配更精准。', icon: '🤝' },
        { title: '交易安全', desc: '资金监管、合同审核、过户陪同，全流程护航。', icon: '🛡️' },
        { title: '本地深耕', desc: '深耕嘉兴十二年，熟悉每一个板块与行情。', icon: '📍' },
      ],
      steps: [
        { t: '需求沟通', d: '登记预算、区域与户型偏好，明确置业目标。' },
        { t: '房源匹配', d: '顾问筛选真实房源，安排实地看房。' },
        { t: '议价签约', d: '协助议价谈判，规范签署交易合同。' },
        { t: '过户交付', d: '资金监管与过户办理，安心交房入住。' },
      ],
    }
  },
  computed: {
    featured() {
      return featuredList
    },
  },
}
</script>

<style scoped>
/* Hero */
.hero {
  background:
    radial-gradient(1200px 500px at 80% -10%, rgba(200,161,90,.16), transparent 60%),
    linear-gradient(160deg, #0e2537 0%, #12395b 55%, #1f5f96 100%);
  background-size: 100% 100%, 180% 180%;
  color: #fff;
  overflow: hidden;
  animation: heroGradient 18s ease-in-out infinite alternate;
}
@keyframes heroGradient {
  0%   { background-position: 80% 0%, 0% 50%; }
  100% { background-position: 60% 10%, 100% 50%; }
}

/* Hero 入场动画 */
.hero__anim {
  opacity: 0;
  transform: translateY(22px);
  animation: heroIn .8s cubic-bezier(.22,.68,.32,1) forwards;
  animation-delay: var(--d, 0ms);
}
@keyframes heroIn {
  to { opacity: 1; transform: none; }
}

/* Hero 卡片轻微浮动 + 入场 */
.hero__float {
  opacity: 0;
  animation: cardIn .9s cubic-bezier(.22,.68,.32,1) .5s forwards;
}
@keyframes cardIn {
  from { opacity: 0; transform: translateY(30px) scale(.98); }
  to   { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {
  .hero { animation: none; }
  .hero__anim, .hero__float { opacity: 1; transform: none; animation: none; }
}
.hero__inner {
  display: grid; grid-template-columns: 1.3fr .85fr; gap: 48px; align-items: center;
  padding: 84px 24px 92px;
}
.hero__eyebrow {
  display: inline-block; font-weight: 700; letter-spacing: 2px;
  color: var(--accent-2); background: rgba(255,255,255,.08);
  padding: 6px 14px; border-radius: 999px; font-size: 13px;
}
.hero__text h1 { font-size: 46px; line-height: 1.2; margin: 18px 0 16px; }
.hero__text > p { color: #c6d3df; font-size: 16px; max-width: 520px; margin: 0 0 28px; }
.hero__actions { display: flex; gap: 14px; flex-wrap: wrap; }
.hero__stats { display: flex; gap: 40px; margin-top: 44px; }
.hero__stats strong { display: block; font-size: 30px; color: var(--accent-2); }
.hero__stats span { color: #b7c6d3; font-size: 14px; }

.hero__card {
  background: #fff; border-radius: 16px; padding: 26px; color: var(--ink);
  box-shadow: 0 24px 60px rgba(0,0,0,.28);
}
.hero__card h3 { margin: 0; color: var(--brand); font-size: 20px; }
.hero__card-sub { color: var(--muted); font-size: 14px; margin: 4px 0 18px; }
.hero__card label { display: block; font-size: 13px; color: var(--muted); margin-bottom: 14px; font-weight: 600; }
.hero__card select {
  width: 100%; margin-top: 6px; padding: 11px 12px; border-radius: 9px;
  border: 1px solid var(--line); background: var(--bg-soft); font-size: 15px; color: var(--ink);
}

/* Features */
.feature {
  background: #fff; border: 1px solid var(--line); border-radius: var(--radius);
  padding: 28px 22px; text-align: center; transition: transform .2s, box-shadow .2s;
}
.feature:hover { transform: translateY(-4px); box-shadow: var(--shadow); }
.feature__icon {
  width: 62px; height: 62px; margin: 0 auto 14px; border-radius: 14px;
  display: grid; place-items: center; font-size: 30px;
  background: linear-gradient(135deg, #eef4fa, #dbe8f4);
}
.feature h3 { margin: 0 0 8px; color: var(--brand); font-size: 18px; }
.feature p { margin: 0; color: var(--muted); font-size: 14px; }

/* Steps */
.steps { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
.step {
  position: relative; padding: 28px 22px; border-radius: var(--radius);
  background: var(--bg-soft); border: 1px solid var(--line);
}
.step__no {
  width: 44px; height: 44px; border-radius: 12px; display: grid; place-items: center;
  font-weight: 800; font-size: 20px; color: #fff; margin-bottom: 14px;
  background: linear-gradient(135deg, var(--brand), var(--brand-2));
}
.step h3 { margin: 0 0 6px; color: var(--brand); font-size: 17px; }
.step p { margin: 0; color: var(--muted); font-size: 14px; }

/* CTA */
.cta { background: linear-gradient(135deg, var(--brand), var(--brand-2)); color: #fff; }
.cta__inner {
  display: flex; align-items: center; justify-content: space-between; gap: 24px;
  padding: 54px 24px; flex-wrap: wrap;
}
.cta h2 { margin: 0 0 6px; font-size: 26px; }
.cta p { margin: 0; color: #d3e0ec; }

@media (max-width: 900px) {
  .hero__inner { grid-template-columns: 1fr; padding: 60px 24px; }
  .hero__text h1 { font-size: 34px; }
  .steps { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 520px) {
  .hero__stats { gap: 24px; }
  .steps { grid-template-columns: 1fr; }
}
</style>
